
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as auth4rM5dSlNzuxQKEqg9IpvP77hvvRI51_45eLSuQlJ4Zl38Meta } from "/home/vsts/work/1/s/pages/access-code/auth.vue?macro=true";
import { default as indexnCf0XAJZQndZ_9OPKVuPz1sWMLQBrPPdf3hAyc48klEMeta } from "/home/vsts/work/1/s/pages/access-code/index.vue?macro=true";
import { default as static_45must_45be_45deletedf4WF9kH32BKCKHeTWiBalCuV25HxLZdW9aZK3jJ0a3AMeta } from "/home/vsts/work/1/s/pages/access-code/static-must-be-deleted.vue?macro=true";
import { default as faqspj_wPXGFl0tZgVLLl7Ziy_7jUyuYmKW3ClBCmNEdo2gMeta } from "/home/vsts/work/1/s/modules/shared/pages/faqs.vue?macro=true";
import { default as permissionsVCaHvSDCxTX7j4vTBjJnUyL4U3cpdSPMe_459o_451P_TesMeta } from "/home/vsts/work/1/s/modules/admin/pages/permissions.vue?macro=true";
import { default as indexx8L2fmaxpJEgCwCXitv2a6QAePpna6dytZKiJOkfL4cMeta } from "/home/vsts/work/1/s/modules/dashboard/pages/index.vue?macro=true";
import { default as index2jt5htpntx9FDvdj2gUMpbHAzC1WWWnwZPTXcM2AYGMQMeta } from "/home/vsts/work/1/s/modules/dashboard/pages/index2.vue?macro=true";
import { default as indexsN0dsy_45OtkM_rzJB_453Y6OvFZq9Dv6G2z8COCWz_4J9gMeta } from "/home/vsts/work/1/s/modules/dashboard/pages/board-messages/index.vue?macro=true";
import { default as indexmcTWYy1pokr00Da4m1qTv5LxZxm5ChguJpxFITwn8RQMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/index.vue?macro=true";
import { default as indexf4nYkEh_45TBhG0_UOftNzUqnARy2Qk7rIAEsiAm9pMrgMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/profile/index.vue?macro=true";
import { default as personal_45informationa5iXnQc327ZxSywg539RNMruU8IVyXNTMqB_45iUiVtPEMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/personal-information.vue?macro=true";
import { default as emergency_45contactsgYyvX1w_45tYujVasBJ9rBHBBG1Fp4HtCnCRWKDyykJAYMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/emergency-contacts.vue?macro=true";
import { default as certificationsm5gSjinCZrdgYzOD_8wHVBRtSgoN1xuOj0ZgB_45xufywMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/certifications.vue?macro=true";
import { default as badge_45verificationQ8HWRs4_ExzysQDWHUf_4p82tvsCl0M8DYJ0nLzxSasMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/profile/badge-verification.vue?macro=true";
import { default as notificationsnuzIjgfQnlwHWuMamAG3YmcfDjA5NS_45VGxKEymSrl94Meta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/notifications.vue?macro=true";
import { default as code_45of_45conduct4YyreBoaxpmrS0_45DZvxiczkn6co5KDH0DL_xiIGa0fwMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/waivers/code-of-conduct.vue?macro=true";
import { default as waiver_45of_45liabilityrfD7y0Rh9j4q65yMwzGk_xMcLY_45GFCTW9nd0pZS_45ahQMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/waivers/waiver-of-liability.vue?macro=true";
import { default as lmsm14i4fCqoWSEJQqAc7XmRXAMw96wx3tH1qatafzHHEgMeta } from "/home/vsts/work/1/s/modules/disaster-worker/pages/lms.vue?macro=true";
import { default as indexusqmiLnPlCkVFXnY3lME4DxQhEJEozH2_455JQlO02NnsMeta } from "/home/vsts/work/1/s/modules/training/pages/courses/index.vue?macro=true";
import { default as newcuLkLqgN6x26bBGelGSo5_45SjYzgnX54yYXZRhc_HheoMeta } from "/home/vsts/work/1/s/modules/training/pages/courses/new.vue?macro=true";
import { default as editVHUbV6_dnCoF6POvFi_452_45Z2xCFSCxw_45nS_45o0fTG3XjcMeta } from "/home/vsts/work/1/s/modules/training/pages/courses/edit.vue?macro=true";
import { default as detailsgPUlBLFzaLSVefkwq_45Lf8IW_1FzT6VKX2_45NaKwiCEMUMeta } from "/home/vsts/work/1/s/modules/training/pages/courses/details.vue?macro=true";
import { default as index5Df0kgBt39r5NMPhGSh_45rR0dKuGZ35pVgAYoWZYMYYYMeta } from "/home/vsts/work/1/s/modules/training/pages/document-library/index.vue?macro=true";
import { default as createfpFNUyMEnSKfM673y3TqV6_PjAEhq2Af_45o_45J5SWiYc4Meta } from "/home/vsts/work/1/s/modules/training/pages/document-library/create.vue?macro=true";
import { default as editUSnQVgdi1IM9VRl3_45wSmaIKNyPoDNCAAck55k6AOUx4Meta } from "/home/vsts/work/1/s/modules/training/pages/document-library/edit.vue?macro=true";
import { default as index_451sWeIY1zlh8t7t_F_CkQONCt9B0w4GD92gEsQl63AgMeta } from "/home/vsts/work/1/s/modules/training/pages/resources/index.vue?macro=true";
import { default as createf8hKtPX9dW21a1KBYBIDne88zPJtHt8lV5i0ibamcEIMeta } from "/home/vsts/work/1/s/modules/training/pages/resources/create.vue?macro=true";
import { default as editOpkBJCehpmwUqBWpKir9rWu9PwX22mHoTdZJcu3LoWUMeta } from "/home/vsts/work/1/s/modules/training/pages/resources/edit.vue?macro=true";
import { default as detailsvBIHqocGtzaObVvnynqqUIWWrgb4XcXdzkZO9JWhzzoMeta } from "/home/vsts/work/1/s/modules/training/pages/resources/details.vue?macro=true";
import { default as documentscP6_7Gbsrt29VcaQYBo_R0LYI3TvJXXrZuXEUBLXmDkMeta } from "/home/vsts/work/1/s/modules/training/pages/resources/[id]/documents.vue?macro=true";
import { default as indexogy13pWaoLAzolUxoQGxAEjNtVKmgIIf3IcozGHHqn0Meta } from "/home/vsts/work/1/s/modules/training/pages/classes/index.vue?macro=true";
import { default as newnkZXVIt_45DJ40kjtwsE788rgUfr1gLAf4WQiNgCEnZBIMeta } from "/home/vsts/work/1/s/modules/training/pages/classes/new.vue?macro=true";
import { default as edit3EPKeQR2w_VhR9GWgThSpb9BbEzR4aiPp7ZwUhI_wq8Meta } from "/home/vsts/work/1/s/modules/training/pages/classes/edit.vue?macro=true";
import { default as detailsFYxFzVRHu2QUK_3yX_qhyceXMSxBS1GlRkDD2f9DMZwMeta } from "/home/vsts/work/1/s/modules/training/pages/classes/details.vue?macro=true";
import { default as active_45reportdHmzIGJohhFIRZxvOIHiAI6gPa9B8fHF_kWUeCh1ZHMMeta } from "/home/vsts/work/1/s/modules/training/pages/classes/active-report.vue?macro=true";
import { default as indexwFTbquA8bu5SzivMqo9zagXUw_455SDy1xpdgnR4Fz8QAMeta } from "/home/vsts/work/1/s/modules/training/pages/certification/index.vue?macro=true";
import { default as indexw7xdzbSNhsjXjxj6MZ67I2cYNZu5SvxnmgeQpYvtPZUMeta } from "/home/vsts/work/1/s/modules/incident/pages/index.vue?macro=true";
import { default as newocuJioCTcX1gfvN_45MzDkVN7fbyj6FY6s7GzrbLAt_45X4Meta } from "/home/vsts/work/1/s/modules/incident/pages/new.vue?macro=true";
import { default as detailsV1W13MycS4pC9BfTn9ERcy11WHwsykPi8xdWKeTrTVsMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/details.vue?macro=true";
import { default as edit6qLZaa7DvukKwKe9kIVfm7hMuS0kX_Ob2IhgUKLnmGoMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/edit.vue?macro=true";
import { default as personnelN7fw0zoqO5Ow2KS_45kzrLe8PFJFw_OPXDwYdWvoEiRoYMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/personnel.vue?macro=true";
import { default as statisticsfjQtDi9LOjtAjH0EmEkdFJyHdoFcIUjNqaiPfR8h_lIMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/statistics.vue?macro=true";
import { default as documentsWYcjiAs4XBAg7QzU2QvYTTDOQFlDjV_45k0C9pfjGLfQkMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/documents.vue?macro=true";
import { default as photos0WaNw4corGflMy9RhIgQIngmYoSYHEgQBfMoeYJ0y90Meta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/photos.vue?macro=true";
import { default as command_45postmB9XUYR8rpXBmpxiMrOay7qbB1B8J7ITsmLTLCEPAeMMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/command-post.vue?macro=true";
import { default as command_45post_45detailsbEtfcsjo2cSOKJC7bS1HI1r0SQFymZ5NdyH8XMBSyMkMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/command-post-details.vue?macro=true";
import { default as incident_45resourceQePtr2rMzkUHg52hwpovHvGpg_45sGUWXxvbVqFI_45iGbsMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/incident-resource.vue?macro=true";
import { default as personnel_45assignmentjih3nQTp0nEUlHgV10qCX5dyWdFoCcXlDh6kloHO9UoMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/personnel-assignment.vue?macro=true";
import { default as statistics_45configurationf3gjT3uRXiRBkxjA5inVovzJQXnd4wBTlt4d5vqftGEMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/statistics-configuration.vue?macro=true";
import { default as statistics_45printRlnRbAbDSOcOet3RfJ6OFBEa3NNgO1aharo4f0wS8rgMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/statistics-print.vue?macro=true";
import { default as volunteers_45print1l2zChkMSic8mKk_45uByGh5bB_6nCxPDR49f3DnDynBMMeta } from "/home/vsts/work/1/s/modules/incident/pages/[id]/volunteers-print.vue?macro=true";
export default [
  {
    name: "access-code-auth",
    path: "/access-code/auth",
    meta: auth4rM5dSlNzuxQKEqg9IpvP77hvvRI51_45eLSuQlJ4Zl38Meta || {},
    component: () => import("/home/vsts/work/1/s/pages/access-code/auth.vue")
  },
  {
    name: "access-code",
    path: "/access-code",
    meta: indexnCf0XAJZQndZ_9OPKVuPz1sWMLQBrPPdf3hAyc48klEMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/access-code/index.vue")
  },
  {
    name: "access-code-static-must-be-deleted",
    path: "/access-code/static-must-be-deleted",
    meta: static_45must_45be_45deletedf4WF9kH32BKCKHeTWiBalCuV25HxLZdW9aZK3jJ0a3AMeta || {},
    component: () => import("/home/vsts/work/1/s/pages/access-code/static-must-be-deleted.vue")
  },
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/home/vsts/work/1/s/modules/shared/pages/faqs.vue")
  },
  {
    name: "admin.permissions",
    path: "/admin/permissions",
    meta: {"middleware":["can-manage"]},
    component: () => import("/home/vsts/work/1/s/modules/admin/pages/permissions.vue")
  },
  {
    name: "dashboard1",
    path: "/dashboard1",
    component: () => import("/home/vsts/work/1/s/modules/dashboard/pages/index.vue")
  },
  {
    name: "²",
    path: "/dashboard2",
    component: () => import("/home/vsts/work/1/s/modules/dashboard/pages/index2.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/vsts/work/1/s/modules/dashboard/pages/index2.vue")
  },
  {
    name: "board-messages",
    path: "/board-messages",
    component: () => import("/home/vsts/work/1/s/modules/dashboard/pages/board-messages/index.vue")
  },
  {
    name: "disaster-worker",
    path: "/disaster-worker",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/index.vue")
  },
  {
    name: "disaster-worker.details",
    path: "/disaster-worker/:id/details",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/index.vue")
  },
  {
    name: "disaster-worker.personal-information.edit",
    path: "/disaster-worker/:id/edit/personal-information",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/personal-information.vue")
  },
  {
    name: "disaster-worker.emergency-contacts.edit",
    path: "/disaster-worker/:id/edit/emergency-contacts",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/emergency-contacts.vue")
  },
  {
    name: "disaster-worker.certifications.edit",
    path: "/disaster-worker/:id/edit/certifications",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/certifications.vue")
  },
  {
    name: "disaster-worker.badge.verification",
    path: "/disaster-worker/badge/verification/:id",
    meta: badge_45verificationQ8HWRs4_ExzysQDWHUf_4p82tvsCl0M8DYJ0nLzxSasMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/badge-verification.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/index.vue")
  },
  {
    name: "profile.personal-information.edit",
    path: "/profile/edit/personal-information",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/personal-information.vue")
  },
  {
    name: "profile.emergency-contacts.edit",
    path: "/profile/edit/emergency-contacts",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/emergency-contacts.vue")
  },
  {
    name: "profile.certifications.edit",
    path: "/profile/edit/certifications",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/certifications.vue")
  },
  {
    name: "dw.notification-settings.edit",
    path: "/disaster-worker/:id/edit/notifications",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/notifications.vue")
  },
  {
    name: "profile.notification-settings.edit",
    path: "/profile/edit/notifications",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/profile/edit/notifications.vue")
  },
  {
    name: "waivers.code-of-conduct",
    path: "/waivers/code-of-conduct",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/waivers/code-of-conduct.vue")
  },
  {
    name: "waivers.waiver-of-liability",
    path: "/waivers/waiver-of-liability",
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/waivers/waiver-of-liability.vue")
  },
  {
    name: "disaster-worker.lms",
    path: "/disaster-worker/lms",
    meta: lmsm14i4fCqoWSEJQqAc7XmRXAMw96wx3tH1qatafzHHEgMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/disaster-worker/pages/lms.vue")
  },
  {
    name: "courses",
    path: "/courses",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/courses/index.vue")
  },
  {
    name: "courses.new",
    path: "/courses/new",
    meta: newcuLkLqgN6x26bBGelGSo5_45SjYzgnX54yYXZRhc_HheoMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/training/pages/courses/new.vue")
  },
  {
    name: "courses.edit",
    path: "/courses/:id/edit",
    meta: editVHUbV6_dnCoF6POvFi_452_45Z2xCFSCxw_45nS_45o0fTG3XjcMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/training/pages/courses/edit.vue")
  },
  {
    name: "courses.details",
    path: "/courses/:id/details",
    meta: detailsgPUlBLFzaLSVefkwq_45Lf8IW_1FzT6VKX2_45NaKwiCEMUMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/training/pages/courses/details.vue")
  },
  {
    name: "document-library",
    path: "/document-library",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/document-library/index.vue")
  },
  {
    name: "document-library.create",
    path: "/document-library/create",
    meta: createfpFNUyMEnSKfM673y3TqV6_PjAEhq2Af_45o_45J5SWiYc4Meta || {},
    component: () => import("/home/vsts/work/1/s/modules/training/pages/document-library/create.vue")
  },
  {
    name: "document-library.edit",
    path: "/document-library/:id/edit",
    meta: editUSnQVgdi1IM9VRl3_45wSmaIKNyPoDNCAAck55k6AOUx4Meta || {},
    component: () => import("/home/vsts/work/1/s/modules/training/pages/document-library/edit.vue")
  },
  {
    name: "resources",
    path: "/resources",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/resources/index.vue")
  },
  {
    name: "resources.create",
    path: "/resources/create",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/resources/create.vue")
  },
  {
    name: "resources.edit",
    path: "/resources/:id/edit",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/resources/edit.vue")
  },
  {
    name: "resources.details",
    path: "/resources/:id/details",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/resources/details.vue")
  },
  {
    name: "resources.documents",
    path: "/resources/:id/documents",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/resources/[id]/documents.vue")
  },
  {
    name: "classes",
    path: "/classes",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/classes/index.vue")
  },
  {
    name: "classes.new",
    path: "/classes/new",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/classes/new.vue")
  },
  {
    name: "classes.edit",
    path: "/classes/:id/edit",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/classes/edit.vue")
  },
  {
    name: "classes.details",
    path: "/classes/:id/details",
    meta: detailsFYxFzVRHu2QUK_3yX_qhyceXMSxBS1GlRkDD2f9DMZwMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/training/pages/classes/details.vue")
  },
  {
    name: "classes.active",
    path: "/classes/active",
    component: () => import("/home/vsts/work/1/s/modules/training/pages/classes/active-report.vue")
  },
  {
    name: "certification",
    path: "/certification/:idClass/:idUser",
    meta: indexwFTbquA8bu5SzivMqo9zagXUw_455SDy1xpdgnR4Fz8QAMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/training/pages/certification/index.vue")
  },
  {
    name: "incidents",
    path: "/incidents",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/index.vue")
  },
  {
    name: "incidents.new",
    path: "/incidents/new",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/new.vue")
  },
  {
    name: "incidents.details",
    path: "/incidents/:id/details",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/details.vue")
  },
  {
    name: "incidents.edit",
    path: "/incidents/:id/edit",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/edit.vue")
  },
  {
    name: "incidents.personnel",
    path: "/incidents/:id/personnel",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/personnel.vue")
  },
  {
    name: "incidents.statistics",
    path: "/incidents/:id/statistics",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/statistics.vue")
  },
  {
    name: "incidents.documents",
    path: "/incidents/:id/documents",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/documents.vue")
  },
  {
    name: "incidents.photos",
    path: "/incidents/:id/photos",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/photos.vue")
  },
  {
    name: "incidents.command-post",
    path: "/incidents/:id/command-post",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/command-post.vue")
  },
  {
    name: "incidents.command-post-details",
    path: "/incidents/:id/command-post-details",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/command-post-details.vue")
  },
  {
    name: "incidents.incident-resource",
    path: "/incidents/:id/incident-resource",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/incident-resource.vue")
  },
  {
    name: "incidents.personnel-assignment",
    path: "/incidents/:id/personnel-assignment",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/personnel-assignment.vue")
  },
  {
    name: "incidents.statistics-configuration",
    path: "/incidents/:id/statistics/configuration",
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/statistics-configuration.vue")
  },
  {
    name: "incidents.statistics-print",
    path: "/incidents/:id/statistics-print/:cpId",
    meta: statistics_45printRlnRbAbDSOcOet3RfJ6OFBEa3NNgO1aharo4f0wS8rgMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/statistics-print.vue")
  },
  {
    name: "incidents.volunteers-print",
    path: "/incidents/:id/volunteers-print/:cpId",
    meta: volunteers_45print1l2zChkMSic8mKk_45uByGh5bB_6nCxPDR49f3DnDynBMMeta || {},
    component: () => import("/home/vsts/work/1/s/modules/incident/pages/[id]/volunteers-print.vue")
  }
]